import * as Sentry from '@sentry/nextjs'

import { ENV_CONFIG } from './envConfig'

function beforeSend(event: Sentry.Event) {
  const exception = event.exception?.values?.[0]

  if (exception?.value.includes('Invariant: attempted to hard navigate to the same URL')) {
    return null
  }

  // Ignore errors from Turnstile captcha
  if (exception?.type === 'TurnstileError') {
    return null
  }

  if (exception?.type === 'AxiosError') {
    // Ignore low level network errors
    if (exception?.value.includes('Network Error')) {
      return null
    }

    // Ignore 403 and 401 errors
    if (exception?.value.includes('Request failed with status code 403')) {
      return null
    }

    if (exception?.value.includes('Request failed with status code 401')) {
      return null
    }
  }

  return event
}

const denyUrls = [
  /googletagmanager\.com/i,
  // Chrome extensions
  /extensions\//i,
  /^chrome:\/\//i,
  /^chrome-extension:\/\//i,
  /^moz-extension:\/\//i,
  /^safari(-web)?-extension:\/\//i,
]

const ignoreErrors = [
  // Random plugins/extensions
  'top.GLOBALS',
  'TabId is undefined',
  "Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.",
  // Browser extensions writing to extension storage from the page
  'Invalid call to browser.storage.local.set()',
  // Android WebView bridge called after the page navigated away (in-app browsers)
  /Java object is gone/,
  // iOS in-app webviews
  'WKWebView API client did not respond to this postMessage',
  // Globals injected by in-app browsers
  "Can't find variable: receiveUserInfo",
  // DuckDuckGo Mobile privacy layer, unhandled rejection without a stack trace
  /^invalid origin$/,
  // Benign browser warning, not a failure (common with animation libraries)
  'ResizeObserver loop completed with undelivered notifications',
  'ResizeObserver loop limit exceeded',
]

export const defaultSentryOptions: Sentry.BrowserOptions | Sentry.NodeOptions | Sentry.EdgeOptions =
  {
    ignoreErrors,
    denyUrls,
    beforeSend,
    tracesSampleRate: 0.1,
    enabled: ENV_CONFIG.NODE_ENV == 'production',
    dsn: ENV_CONFIG.SENTRY_DSN,
    environment: ENV_CONFIG.NODE_ENV,
  }
